import React, { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Steps } from "primereact/steps";
import { Toast } from "primereact/toast";
import SchoolInfoStep from "./steps/SchoolInfoStep";
import AdminAccountStep from "./steps/AdminAccountStep";
import AcademicConfigStep from "./steps/AcademicConfigStep";
import ReviewStep from "./steps/ReviewStep";
import ProvisioningStep from "./steps/ProvisioningStep";
import "./SetupWizard.scss";

const STEPS = [
  { label: "School Info" },
  { label: "Academics" },
  { label: "Admin" },
  { label: "Review" },
  { label: "Setup" },
];

function SetupWizardContent({ onClose }) {
  const toast = useRef(null);
  const [activeStep, setActiveStep] = useState(0);
  const [schoolId, setSchoolId] = useState(null);

  const [formData, setFormData] = useState({
    // School Info
    schoolName: "",
    email: "",
    phone: "",
    address: "",
    country: "",
    // Admin Account
    adminName: "",
    adminEmail: "",
    adminPassword: "",
    confirmPassword: "",
    // Academic Config
    sessionName: "",
    sessionStartDate: null,
    sessionEndDate: null,
    gradePreset: "k-12",
    // Plan — silently default to free
    planId: null,
    billingCycle: "monthly",
    selectedPlan: null,
  });

  const updateField = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const nextStep = () => {
    setActiveStep((prev) => Math.min(prev + 1, STEPS.length - 1));
  };

  const prevStep = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <SchoolInfoStep
            formData={formData}
            updateField={updateField}
            onNext={nextStep}
          />
        );
      case 1:
        return (
          <AcademicConfigStep
            formData={formData}
            updateField={updateField}
            onNext={nextStep}
            onBack={prevStep}
          />
        );
      case 2:
        return (
          <AdminAccountStep
            formData={formData}
            updateField={updateField}
            onNext={nextStep}
            onBack={prevStep}
            toast={toast}
          />
        );
      case 3:
        return (
          <ReviewStep
            formData={formData}
            onNext={nextStep}
            onBack={prevStep}
            setSchoolId={setSchoolId}
            toast={toast}
          />
        );
      case 4:
        return <ProvisioningStep schoolId={schoolId} onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <Steps
        model={STEPS}
        activeIndex={activeStep}
        readOnly
        className="setup-steps mb-3"
      />
      <div className="setup-wizard-content">{renderStep()}</div>
    </>
  );
}

// Dialog mode — used from Login page
export function SetupWizardDialog({ visible, onHide }) {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Register Your School"
      modal
      dismissableMask
      style={{ width: "60vw", maxWidth: "900px" }}
      breakpoints={{ "960px": "90vw" }}
      contentStyle={{ padding: "1rem 1.5rem" }}
    >
      <SetupWizardContent onClose={onHide} />
    </Dialog>
  );
}

// Standalone page mode — used for /setup route and platform admin
export default function SetupWizard() {
  return (
    <div className="setup-wizard-container">
      <div className="setup-wizard-card">
        <h2>School Setup Wizard</h2>
        <SetupWizardContent />
      </div>
    </div>
  );
}
